<span
	tuiBadge
	appearance="neutral"
	size="m"
	class="cursor-pointer"
	[tuiHint]="hint"
	tuiHintDirection="bottom"
	(pointerenter)="ensureLoaded()"
>
	{{ displayedCount() }}
</span>

<ng-template #hint>
	@if (loading()) {
		<div class="flex min-w-24 justify-center py-2">
			<tui-loader size="s" />
		</div>
	} @else if (resolvedItems().length) {
		<ul class="m-0 list-none p-0 text-left">
			@for (item of resolvedItems(); track $index) {
				<li>{{ item }}</li>
			}
		</ul>
	} @else {
		{{ 'generic.none' | transloco }}
	}
</ng-template>
